import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Category } from '@/types/category'

export function createCategory(
  body: Category
): Promise<AxiosResponse<Category>> {
  return instance.post(`/category`, body)
}
